<template>
    <div class="refund-Dialog">
        <el-dialog
            :visible.sync="visible"
            v-if="contractInfo"
            class="refund-dialog-title"
            title="退款">
            <div class="refund-card-top">
                <div class="flex items-center">
                    <div class="refund-card-left">
                        {{ $t('Common.name') }}：{{ contractInfo.clientName }}
                    </div>
                    <div class="refund-card-right">
                        {{ $t('Common.phone') }}：{{ contractInfo.clientPhone }}
                    </div>
                </div>
                <div class="flex items-center">
                    <div class="refund-card-left">
                        {{ $t('Contract.number') }}：{{ contractInfo.contractNum }}
                    </div>
                    <div class="refund-card-right">
                        {{ $t('Member.saler') }}：{{ contractInfo.contractSalesStaffNickname }}
                    </div>
                </div>

                <!-- 不同合同不同数据 -->
                <div v-if="activeName === 'member' || activeName === 'cardsCon'">
                    <div>
                        {{ $t('Contract.card_name') }}：{{ contractInfo.cardName }}
                    </div>
                    <div>
                        {{ $t('Contract.support_store') }}：{{ contractInfo.supportStoreNames }}
                    </div>
                    <div class="flex items-center">
                        <div class="refund-card-left">
                            {{ $t('Sell.Pay.buy') }}：{{ contractInfo.cardCredit }}
                        </div>
                        <div class="refund-card-right">
                            {{ $t('Reception.First.remaining') }}：{{ contractInfo.cardBalance }}
                        </div>
                    </div>
                </div>
                <!-- 定金 -->
                <div v-if="activeName === 'subscription'">
                    <div class="flex items-center">
                        <div class="refund-card-left">{{ $t('Common.cabinet_number') }}：</div>
                        <div class="refund-card-right">
                            {{ $t('Charge.amount_receivable') }}：0.00{{ $t('Reception.Fifth.yuan') }}
                        </div>
                    </div>
                    <div>
                        {{ $t('Charge.deposit_amount') }}：{{ contractInfo.amt }}
                         {{ $t('Reception.Fifth.yuan') }}
                    </div>
                </div>
                <!-- 押金 -->
                <div v-if="activeName === 'deposit'">
                    <div class="flex items-center">
                        <div class="refund-card-left">
                            {{ $t('Common.cabinet_number') }}：{{ contractInfo.lockerCode }}
                        </div>
                        <div class="refund-card-right">
                            {{ $t('Sell.yajin_money') }}：{{ contractInfo.amt }}
                             {{ $t('Reception.Fifth.yuan') }}
                        </div>
                    </div>
                </div>
                <!-- 私教 -->
                <div v-if="activeName === 'personal'">
                    <div>{{ $t('Course.coach') }}：{{ contractInfo.coachNickname }}</div>
                    <div class="flex items-center">
                        <div class="refund-card-left">
                            {{ $t('Course.name') }}：{{ contractInfo.lessonName }}
                        </div>
                        <div class="refund-card-right">
                            {{ $t('Member.price_level') }}：{{ contractInfo.priceLevel }}
                        </div>
                    </div>
                    <div class="flex items-center">
                        <div class="refund-card-left">
                            {{ $t('Sell.Pay.buy') }}：{{ contractInfo.lessonCredit }}{{ $t('Board.Team.festival') }}
                        </div>
                        <div class="refund-card-right">
                            {{ $t('Reception.First.remaining') }}：{{ contractInfo.lessonBalance }}{{ $t('Board.Team.festival') }}
                        </div>
                    </div>
                </div>
                <!-- 租赁柜 -->
                <div v-if="activeName === 'locker'">
                    <div class="flex items-center">
                        <div class="refund-card-left">
                            {{ $t('Common.cabinet_number') }}：{{ contractInfo.lockerCode }}
                        </div>
                        <div class="refund-card-right">
                            {{ $t('Charge.amount_receivable') }}：{{ contractInfo.payableAmt }}
                             {{ $t('Reception.Fifth.yuan') }}
                        </div>
                    </div>
                    <div class="flex items-center">
                        <div>
                            {{ $t('Sell.Charge.paid_amount') }}：{{ contractInfo.paidAmt }}
                             {{ $t('Reception.Fifth.yuan') }}
                        </div>
                    </div>
                </div>
                <!-- public -->
                <div
                    class="flex items-center"
                    v-if="activeName === 'member' || activeName === 'personal' || activeName === 'cardsCon'">
                    <div class="refund-card-left">
                        {{ $t('Charge.amount_receivable') }}：{{ contractInfo.payableAmt }}
                         {{ $t('Reception.Fifth.yuan') }}
                    </div>
                    <div class="refund-card-right">
                        {{ $t('Sell.Charge.paid_amount') }}：{{ contractInfo.paidAmt }}
                         {{ $t('Reception.Fifth.yuan') }}
                    </div>
                </div>
                <div v-if="activeName !== 'deposit'">{{ $t('Contract.start_end_date') }}：
                    <span v-if="contractInfo.startAt && contractInfo.endAt">
                        {{ contractInfo.startAt }} ~ {{ contractInfo.endAt }}
                    </span>
                </div>
                <!-- 租赁柜 -->
                <div v-if="activeName === 'locker'">
                    <div class="flex items-center">
                        <div>{{ $t('Week.lease_period2') }}：{{ contractInfo.leaseStr }}</div>
                    </div>
                </div>
            </div>

            <!-- 相同样式开始 -->
            <el-form
                class="refun-card-center"
                ref="form"
                :model="form"
                :rules="rules"
                label-suffix=":"
                label-width="80px"
                :status-icon="true">
                <el-form-item
                    :label="$t('Common.reason')"
                    v-if="activeName !== 'deposit'">
                    <!--  && activeName !== 'subscription' -->
                    <el-radio
                        :class="activeName === 'subscription' && item.code === 4 ? 'none' : ''"
                        v-model="form.reason"
                        :label="item.code"
                        v-for="(item, index) in contractReason"
                        :key="index">
                        {{ item.name }}
                    </el-radio>
                </el-form-item>
                <!-- 押金退款原因 -->
                <el-form-item
                    :label="$t('Common.reason')"
                    v-if="activeName === 'deposit'">
                    <el-select style="width: 186px" v-model="form.reason">
                        <el-option
                            v-for="item in optionsReason"
                            :key="item.value"
                            :label="item.label"
                            :value="Number(item.value)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- public -->
                <el-form-item
                    :label="$t('Sell.refund2')"
                    class="flex items-center refund-dialog-amt">
                    <el-input
                        type="number"
                        :min="1"
                        v-model.number="form.money"
                        style="width: 168px"
                        :placeholder="$t('Fill.amt')">
                    </el-input> {{ $t('Reception.Fifth.yuan') }}
                </el-form-item>
                <el-form-item :label="$t('Sell.Dialog.refund_method')">
                    <el-select style="width: 186px" v-model="form.payMethodCode">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="Number(item.value)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Common.remark')">
                    <el-input
                        style="width: 250px"
                        type="textarea"
                        :rows="5"
                        :placeholder="$t('Common.remark_placeholder')"
                        v-model="form.remark">
                    </el-input>
                </el-form-item>
                <div class="refund-card-btn">
                    <el-button
                        @click="submit"
                        type="primary"
                    >{{ $t('Message.confirm') }}</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import { Dialog, DatePicker, Radio, RadioGroup } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
    },
    props: ['activeName'],
    data() {
        return {
            // new
            visible: false,
            form: {
                reason: 4,
                money: null,
                payMethodCode: 4,
                remark: null,
            },
            rules: {},
            contractNum: null,
            type: null,
            contractInfo: {},
            contractReason: [
                {
                    code: 4,
                    name: this.$t('Sell.Refund.option1'),
                }, {
                    code: 5,
                    name: this.$t('Sell.Refund.option2'),
                }, {
                    code: 6,
                    name: this.$t('Sell.Refund.option3'),
                },
            ],
            optionsReason: [
                {
                    value: 7,
                    label: this.$t('Sell.Refund.option4'),
                }, {
                    value: 6,
                    label: this.$t('Sell.Refund.option5'),
                },
            ],
            options: [
                {
                    value: 4,
                    label: this.$t('Sell.Pay.cash'),
                }, {
                    value: 6,
                    label: this.$t('Sell.Pay.swipe'),
                }, {
                    value: 3,
                    label: this.$t('Sell.Pay.bank'),
                }, {
                    value: 7,
                    label: this.$t('Sell.Pay.alipay'),
                }, {
                    value: 8,
                    label: this.$t('Sell.Pay.wechat'),
                }, {
                    value: 5,
                    label: this.$t('Sell.Pay.other'),
                }, {
                    value: 9,
                    label: this.$t('Member.revenueflow.payable_instalments'),
                },
            ],
        };
    },
    methods: {
        open(client) {
            this.contractNum = client.contractNum;
            this.fetchDesc();
            this.fetchData();
        },
        fetchDesc() {
            if (this.activeName === 'member') this.type = 'mshp';
            else if (this.activeName === 'personal') this.type = 'coach';
            else if (this.activeName === 'locker') this.type = 'locker';
            else if (this.activeName === 'cardsCon') this.type = 'cz-card';
            else if (this.activeName === 'subscription') this.type = 'prepay';
            else if (this.activeName === 'deposit') {
                this.type = 'deposit';
                this.form.reason = 6;
            }
        },
        fetchData() {
            API.get(`contract/${this.type}/${this.contractNum}`)
            .then(res => {
                this.contractInfo = res;
                this.visible = true;
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                if (Number(this.form.money) > Number(this.contractInfo.paidAmt))
                return $ele.$message(this.$t('Sell.Refund.tip'));
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            API.post(`contract/${this.type}/${this.contractNum}/refund`, form)
            .then(() => {
                $ele.$message.success(this.$t('Sell.Refund.success'));
                this.visible = false;
                this.$emit('fetchData');
            });
        },
    },
};
</script>
<style lang="scss">
.refund-Dialog {
    .el-dialog {
        width: 560px;
    }
    .el-radio__label {
        font-size: 12px;
        color: #666;
        font-weight: 400;
    }
    .card-pay-left {
        margin: 10px 10px 10px 20px;
        font-size: 12px;
    }
    .refund-card-pay {
        margin-bottom: 20px;
    }
    .el-radio {
        width: 100%;
        margin: 5px 0;
    }
    .none {
        display: none;
    }
}
.refund-card-top {
    padding: 10px;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    border: 1px solid rgb(230, 230, 230);
    margin-bottom: 25px;
}
.refund-card-left {
    width: 50%;
}
.refund-card-right {
    width: 50%;
}
.card-bottom-item {
    color: #4c4c4c;
    font-size: 12px;
    width: 60%;
    margin-bottom: 15px;
}
.card-bottom-item-left {
    margin-right: 10px;
    white-space: nowrap;
}
.refund-card-btn {
    padding-top: 20px;
    text-align: center;
}
.refund-dialog-amt {
    .el-form-item__content {
        margin-left: 0 !important;
    }
}
</style>
